<template>
        <div class="col-12 item-container pointer box-shadow" @click.stop="$emit('edit', team)">
            <b-row class="nopads">
                <div class="col-3 item-pic"
                     v-bind:style="{ backgroundImage: 'url(' + teamLogo + ')' }"/>
                <div class="col-9 item-content">
                    <div class="col-12">
                        <h4>{{ team.name }}</h4>
                    </div>
                    <div class="col-12">
                        <p class="p-small item-description">{{ team.description }}</p>
                    </div>
                </div>
            </b-row>
        </div>
</template>

<script>

    import {timeMixin} from "../../mixins/TimeMixin";
    import {userHelper} from "../../mixins/UserMixin";
    import FairApi from "../../modules/api";

    export default {
        name: 'team-item',
        mixins: [timeMixin, userHelper],
        props: {
            team: {
                type: Object,
                default: null
            }
        },

        data() {
            return {
                teamBackgroundImage: '',
                teamLogo: ''
            }
        },

        created() {
            // this.fetchBackgroundImage()
            this.fetchLogo()
        },

        methods: {
            fetchBackgroundImage() {
                if (this.team.background) {
                    FairApi.get(FairApi.photo(this.team.background.id), this.success, function () {
                    })
                }
            },

            fetchLogo() {
                if (this.team.logo) {
                    FairApi.get(FairApi.photo(this.team.logo.id), this.success, function(){})
                }
            },

            success(response) {
                this.teamLogo = response
            }
        }
    }
</script>
